import { Capacitor } from "@capacitor/core";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Returns the absolute base URL for API calls.
 * On native (Capacitor) the web view doesn't have a real host,
 * so we point directly at the production server.
 * On web, returns "" so that relative paths go through the same origin / proxy.
 */
export const API_BASE = Capacitor.isNativePlatform()
  ? "https://app.smartpoker.app"
  : "";

export const SUIT_SYMBOLS: Record<string, string> = {
  s: "♠",
  h: "♥",
  d: "♦",
  c: "♣",
};

export const parseCard = (cardString: string) => {
  if (typeof cardString !== 'string' || cardString.length < 2) {
    return { rank: '?', suit: { symbol: '?' } };
  }
  const rank = cardString.slice(0, -1);
  const suitKey = cardString.slice(-1);
  const symbol = SUIT_SYMBOLS[suitKey.toLowerCase()] ?? suitKey;
  return { rank, suit: { symbol } };
};
